import { computeRemSize } from '@ydistri/theme';
import { CalculationStatisticStoreTargetResponse } from '@ydistri/api-sdk';
import { useMemo } from 'react';
import { useCurrency } from '../../../../../hooks/useCurrency';
import {
  EntityColumns,
  useStoreTableColumnsProvider,
} from '../../../../../hooks/useEntityTableColumnsProvider';
import { getStatisticsTargetStoresTableColumns } from './statisticsModalTableColumns';
import { ColumnsType } from 'antd/es/table';

export const useTableTargetStoreColumns = (
  displayDepartment = false,
): ColumnsType<CalculationStatisticStoreTargetResponse> => {
  const currencyId = useCurrency();
  const storeColumnsProvider = useStoreTableColumnsProvider();

  return useMemo(() => {
    const columnConfig = {
      [EntityColumns.ID]: {
        width: computeRemSize(120),
      },
      [EntityColumns.CODE]: {
        width: computeRemSize(120),
      },
    };

    const storeColumns = storeColumnsProvider<CalculationStatisticStoreTargetResponse>(
      columnConfig,
      'targetStore',
      'Target Store',
    );

    return getStatisticsTargetStoresTableColumns(currencyId, displayDepartment, storeColumns);
  }, [currencyId, displayDepartment, storeColumnsProvider]);
};
